import { render, staticRenderFns } from "./WinningTogetherPopup.vue?vue&type=template&id=487a3633&scoped=true&"
import script from "./WinningTogetherPopup.vue?vue&type=script&lang=js&"
export * from "./WinningTogetherPopup.vue?vue&type=script&lang=js&"
import style0 from "./WinningTogetherPopup.vue?vue&type=style&index=0&id=487a3633&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487a3633",
  null
  
)

export default component.exports